// @flow

export default {
  "urn:jsonschema:eu:firstcare:api:v1:dto:absencerecording:absence:AbsenceCallReasonAndDurationDTO": [
    // Rule 1:
    // Remove consent to share if client settings do not require consent
    {
      tests: [{ path: "/settings/settings/clientSettings/blockConsent", value: true }],
      filters: ["hasConsentToShare"],
    },
    // Rule 2:
    // Remove reasons dropdown and consent to share based on
    //  - employee identity service settings do not require consent
    //  - the caller's identity being a third party caller
    ...[
      "SPOUSE_OR_PARTNER",
      "RELATIVE",
      "FRIEND",
      "MANAGER_OR_SUPERVISOR",
      "HR",
      "COLLEAGUE",
      "THIRD_PARTY_HISTORIC",
    ].map((callerIdentity: string) => ({
      tests: [
        {
          path: "/settings/settings/serviceSettings/employeeIdentity/thirdPartyConsent",
          value: false,
        },
        {
          path: "/recording/callInteraction/callerIdentity",
          value: callerIdentity,
        },
      ],
      filters: ["absenceReason", "hasConsentToShare"],
    })),
  ],
};
